import { render, staticRenderFns } from "./EditLottoTransfer.vue?vue&type=template&id=11073070&"
import script from "./EditLottoTransfer.vue?vue&type=script&lang=js&"
export * from "./EditLottoTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EditLottoTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports